import * as mapWork from "./map.js";
export default {
  data() {
    return {
      transparency_show: true,
      surfaceOpacity: 1,
      layerOpacity: 1,
      layerBrightness: 1,
      layerContrast: 1,
      layerHue: 0,
      layerSaturation: 1,
      layerGamma: 1,
      isFold: false,
    };
  },
  methods: {
    adjustSurfaceOpacity() {
      this.$store.state.terrainTransparency = this.surfaceOpacity;
      mapWork.adjustUndergroundAlpha(this.surfaceOpacity);
    },
    adjustLayerTransparency() {
      this.$store.state.layerOpacity = this.layerOpacity;
      mapWork.adjustTileOpacity(this.layerOpacity);
    },
    adjustLayerBrightness() {
      this.$store.state.layerBrightness = this.layerBrightness;
      mapWork.adjustTileBrightness(this.layerBrightness);
    },
    adjustLayerContrast() {
      this.$store.state.layerContrast = this.layerContrast;
      mapWork.adjustTileContrast(this.layerContrast);
    },
    adjustLayerHue() {
      this.$store.state.layerHue = this.layerHue;
      mapWork.adjustTileHue(this.layerHue);
    },
    adjustLayerSaturation() {
      this.$store.state.layerSaturation = this.layerSaturation;
      mapWork.adjustTileSaturation(this.layerSaturation);
    },
    adjustLayerGamma() {
      this.$store.state.layerGamma = this.layerGamma;
      mapWork.adjustTileGamma(this.layerGamma);
    },
    transparencyBox_close() {
      // this.transparency_show = false;
      this.$emit("transparencyBox_close");
    },
  },
  mounted() {
    this.surfaceOpacity = this.$store.state.terrainTransparency || 1;
    this.layerOpacity = this.$store.state.layerOpacity || 1;
    this.layerBrightness = this.$store.state.layerBrightness || 1;
    this.layerContrast = this.$store.state.layerContrast || 1;
    this.layerHue = this.$store.state.layerHue || 0;
    this.layerSaturation = this.$store.state.layerSaturation || 1;
    this.layerGamma = this.$store.state.layerGamma || 1;

    mapWork.adjustUndergroundAlpha(this.surfaceOpacity);
    mapWork.adjustTileOpacity(this.layerOpacity);
    mapWork.adjustTileBrightness(this.layerBrightness);
    mapWork.adjustTileContrast(this.layerContrast);
    mapWork.adjustTileHue(this.layerHue);
    mapWork.adjustTileSaturation(this.layerSaturation);
    mapWork.adjustTileGamma(this.layerGamma);
  },

  destroyed() {},
  watch: {},
  filters: {
    numFilter(value) {
      let realVal = parseFloat(value).toFixed(2);
      return realVal;
    },
  },
};
